import { ApolloQueryResult } from '@apollo/client';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IGroupPortal } from 'src/models/groupPortal';

interface IGroupPortalSlice {
  groupPortalList: ApolloQueryResult<IGroupPortal[]>;
  selectedGroupPortalIdOfm: string[];
  selectedGroupPortalIdOnm: string[];
  selectedGroupPortalIdOnmExclude: string[];
}

const initState: IGroupPortalSlice = {
  groupPortalList: {
    data: [],
    loading: false,
    networkStatus: 1,
    partial: false
  },
  selectedGroupPortalIdOfm: [],
  selectedGroupPortalIdOnm: [],
  selectedGroupPortalIdOnmExclude: []
};

export const groupPortalSlice = createSlice({
  name: 'groupPortal',
  initialState: initState,
  reducers: {
    updateGroupPortalList: (
      state: IGroupPortalSlice,
      action: PayloadAction<ApolloQueryResult<IGroupPortal[]>>
    ) => {
      state.groupPortalList = action.payload;
    },
    updateSelectedGroupPortalIdOfm: (
      state: IGroupPortalSlice,
      action: PayloadAction<string[]>
    ) => {
      state.selectedGroupPortalIdOfm = action.payload;
    },
    toggleSelectedGroupPortalIdOfm: (
      state: IGroupPortalSlice,
      action: PayloadAction<string>
    ) => {
      if (state.selectedGroupPortalIdOfm.includes(action.payload)) {
        state.selectedGroupPortalIdOfm = [
          ...state.selectedGroupPortalIdOfm.filter(
            (el) => el !== action.payload
          )
        ];
      } else {
        state.selectedGroupPortalIdOfm = [
          ...state.selectedGroupPortalIdOfm,
          action.payload
        ];
      }
    },
    updateSelectedGroupPortalIdOnm: (
      state: IGroupPortalSlice,
      action: PayloadAction<string[]>
    ) => {
      state.selectedGroupPortalIdOnm = action.payload;
    },
    toggleSelectedGroupPortalIdOnm: (
      state: IGroupPortalSlice,
      action: PayloadAction<string>
    ) => {
      if (state.selectedGroupPortalIdOnm.includes(action.payload)) {
        state.selectedGroupPortalIdOnm = [
          ...state.selectedGroupPortalIdOnm.filter(
            (el) => el !== action.payload
          )
        ];
      } else {
        state.selectedGroupPortalIdOnm = [
          ...state.selectedGroupPortalIdOnm,
          action.payload
        ];
      }
    },
    updateSelectedGroupPortalIdOnmExclude: (
      state: IGroupPortalSlice,
      action: PayloadAction<string[]>
    ) => {
      state.selectedGroupPortalIdOnmExclude = action.payload;
    },
    toggleSelectedGroupPortalIdOnmExclude: (
      state: IGroupPortalSlice,
      action: PayloadAction<string>
    ) => {
      if (state.selectedGroupPortalIdOnmExclude.includes(action.payload)) {
        state.selectedGroupPortalIdOnmExclude = [
          ...state.selectedGroupPortalIdOnmExclude.filter(
            (el) => el !== action.payload
          )
        ];
      } else {
        state.selectedGroupPortalIdOnmExclude = [
          ...state.selectedGroupPortalIdOnmExclude,
          action.payload
        ];
      }
    }
  }
});

export const {
  updateGroupPortalList,
  updateSelectedGroupPortalIdOfm,
  toggleSelectedGroupPortalIdOfm,
  updateSelectedGroupPortalIdOnm,
  toggleSelectedGroupPortalIdOnm,
  updateSelectedGroupPortalIdOnmExclude,
  toggleSelectedGroupPortalIdOnmExclude
} = groupPortalSlice.actions;
export default groupPortalSlice.reducer;
